import { render, staticRenderFns } from "./payments-methods.vue?vue&type=template&id=8081a554&"
import script from "./payments-methods.vue?vue&type=script&lang=js&"
export * from "./payments-methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports